import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  styled,
} from "@mui/material";
import React, { forwardRef } from "react";

const StyledIconButton = styled(MuiIconButton)(() => {
  return {};
});

interface ButtonProps extends MuiIconButtonProps {
  children: React.ReactNode;
}

export const IconButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <StyledIconButton ref={ref} {...props}>
        {children}
      </StyledIconButton>
    );
  }
);

export default IconButton;
